<agpr-take-over-panel
    class="agpr-reportImportMentionDialog-container"
    [id]="'reportImportMentionDialog_takeOverPanel'"
    header="Reports.topMentions.topCuratedMentions.dialog.header"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    [responsiveWidth]="true"
    [minPanelWidth]="800"
    [maxPanelWidth]="1000"
    (visibleChange)="doHide()"
>
    <agpr-add-mentions-widget
        #addMentionsWidget
        [id]="'reportImportMentionDialog_addMentionsWidget'"
        [showSelectToggle]="false"
        [onlySocial]="onlySocial"
        [mentionBadges]="mentionBadges"
        [shouldCheckboxBeDisabled]="maxMentionsReached"
        (searchMentionsChange)="setSearchMentions($event)"
        (selectedMentionsChange)="setSelectedMentions($event)"
        (addMentions)="addMentions()"
    ></agpr-add-mentions-widget>

    <ng-template #takeOverFooterLeft>
        <agpr-button
            [id]="'reportImportMentionDialog_cancelButton'"
            label="close"
            [style]="buttonTypes.secondary"
            (click)="this.hideSlideOverlay = true;"
        ></agpr-button>
    </ng-template>
    <ng-template #takeOverFooterRight>
        <span>{{ 'Reports.topMentions.topCuratedMentions.dialog.selectionMessage' | localize: { current: addedMentionNumber + selectedMentions.length, total: maxSelection } }}</span>
        <agpr-button
            [id]="'reportImportMentionDialog_addMentionsButton'"
            label="add"
            [style]="buttonTypes.primary"
            [disabled]="maxMentionsAdded"
            (click)="addMentions()"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
